import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { UpsertAliasRequestBody, IAliasService, IAliasRepository } from '../entities';

export class AliasServiceImpl implements IAliasService {
  itemRepo: IAliasRepository;

  constructor(ir: IAliasRepository) {
    this.itemRepo = ir;

    this.UpsertAlias = this.UpsertAlias.bind(this);
    this.DeleteAlias = this.DeleteAlias.bind(this);
  }

  // TODO: add correct data types
  UpsertAlias({
    customerId,
    accountId,
    data,
    successCallback,
  }: {
    customerId: Nullable<string>;
    accountId: Nullable<number>;
    data: UpsertAliasRequestBody;
    successCallback: SuccessCallback;
  }): Promise<{}> {
    return this.itemRepo.UpsertAlias(customerId, accountId, data, successCallback);
  }

  // TODO: add correct data types
  DeleteAlias({
    customerId,
    accountId,
    successCallback,
  }: {
    customerId: Nullable<string>;
    accountId: Nullable<number>;
    successCallback: SuccessCallback;
  }): Promise<{}> {
    return this.itemRepo.DeleteAlias(customerId, accountId, successCallback);
  }
}
